import { useForm } from "antd/lib/form/Form";
import { IExamination } from "@/models/Examination";
import { useAppDispatch } from "@/hooks/redux";
import {
  clearExaminationForm,
  fillExaminationFields,
} from "@/store/reducers/examinationForm/examinationFormSlice";

const useExaminationForm = () => {
  const dispatch = useAppDispatch();
  const [form] = useForm();

  const clearForm = () => {
    dispatch(clearExaminationForm());
  };

  const setExaminationFields = (examination: IExamination) => {
    dispatch(
      fillExaminationFields({
        examMode: examination.examMode,
        sampleManufacturerName: examination.sampleManufacturerName,
        sampleType: examination.sampleType,
        sampleName: examination.sampleName,
        sampleManufacturedDate: examination.sampleManufacturedDate,
        sampleSerialNumber: examination.sampleSerialNumber,
        operator: examination.operator,
        notes: examination.notes,
      })
    );
  };

  return {
    form,
    clearForm,
    setExaminationFields,
  };
};

export default useExaminationForm;
